import {ProvidersEnum} from '../../../../util/type';

export enum LocationsTableColumnsEnum {
    CompanyName = 'companyName',
    CompanyAddress = 'companyAddress',

    CatalogImpressionsSuffix = 'impressions',
    CatalogConversionSuffix = 'conversion',
    CatalogCallClicksSuffix = 'callClicks',
    CatalogWebsiteClicksSuffix = 'websiteClicks',
    CatalogDirectionRequestsSuffix = 'directionRequests',
    CatalogOtherSuffix = 'other',
}

export type LocationsTableSorterKeysType =
    | LocationsTableColumnsEnum.CompanyName
    | LocationsTableColumnsEnum.CompanyAddress
    | `${ProvidersEnum}_${Exclude<
          LocationsTableColumnsEnum,
          LocationsTableColumnsEnum.CompanyName | LocationsTableColumnsEnum.CompanyAddress
      >}`;
